import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const PublicLayout = ({ children, minimal = false }) => {
  if (minimal) {
    // Minimal layout for homepage and public views (sin header redundante)
    return (
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        {children}
      </Box>
    );
  }

  // Full public layout for homepage, etc.
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.paper',
      }}
    >
      <Box component="header" sx={{ px: 2, py: 2, display: 'flex', alignItems: 'center' }}>
        <Stack direction="row" spacing={1.5} alignItems="center" component={Link} to="/">
          <Box component="img" src="/icons/logo-horizontal.svg" alt="CardQr" sx={{ height: 38 }} />
        </Stack>
      </Box>
      <Box component="main">
        {children}
      </Box>
    </Box>
  );
};

export default PublicLayout; 